import { UploadcareImage } from '@prezly/uploadcare';
import { OG_IMAGE_API_URL } from "./constants.mjs";
export function getLogoUrl(newsroom, previewSize) {
  if (newsroom.newsroom_logo) {
    var image = UploadcareImage.createFromPrezlyStoragePayload(newsroom.newsroom_logo);
    if (previewSize) {
      return image.preview(previewSize, previewSize).cdnUrl;
    }
    return image.cdnUrl;
  }
  return '';
}
export function getFaviconUrl(newsroom) {
  var previewSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var imageObject = newsroom.icon || newsroom.square_logo;
  if (imageObject) {
    var image = UploadcareImage.createFromPrezlyStoragePayload(imageObject);
    return image.preview(previewSize, previewSize).cdnUrl;
  }
  return undefined;
}
export function getOgImageUrl(newsroom, locale) {
  var url = "".concat(OG_IMAGE_API_URL, "/").concat(newsroom.uuid);
  if (locale) {
    return "".concat(url, "?locale=").concat(locale.slug);
  }
  return url;
}